const t = ["none", "sm", "md", "lg"], e = ["sm", "md", "lg", "fullpage"], o = ["log", "warn", "error"], s = [
  "date",
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url",
  "time",
  "color",
  "file",
  "datetime-local"
], c = [
  "date",
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url",
  "time",
  "file",
  "color",
  "checkbox",
  "radio",
  "select",
  "checkbox-group",
  "radio-group",
  "combobox",
  "datetime-local"
], n = [
  "2",
  "4",
  "6",
  "8",
  "10",
  "12",
  "16",
  "25perc",
  "50perc",
  "75perc"
], l = ["none", "xs", "sm", "md", "lg", "xl"], r = [
  "danger",
  "info",
  "success",
  "warning"
], a = [
  "auto",
  "bottom-start",
  "bottom",
  "bottom-end",
  "top-start",
  "top",
  "top-end",
  "left-start",
  "left",
  "left-end",
  "right-start",
  "right",
  "right-end"
], i = ["inline", "overlay"], d = ["h2", "h3", "h4", "h5", "h6"], E = [
  "blockquote",
  "bold",
  "code",
  "display",
  "display1",
  "display2",
  "display3",
  "display4",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "italic",
  "lead",
  "small",
  "cite",
  "caption"
], h = [
  "inherit",
  "left",
  "center",
  "right",
  "justify"
], T = [
  "p",
  "div",
  "span",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "code",
  "blockquote",
  "caption",
  "cite",
  "small"
], S = [
  "body",
  "danger",
  "info",
  "muted",
  "primary",
  "success",
  "warning",
  "positive",
  "negative"
], m = [
  "around",
  "between",
  "center",
  "evenly",
  "left",
  "right"
], p = ["bottom", "middle", "stretch", "top"];
export {
  i as DISPLAY_MODES,
  a as FLOATING_UI_ALIGNS,
  c as FORM_ELEMENT_TYPES,
  n as FORM_ELEMENT_WIDTHS,
  l as GUTTER_SIZES,
  d as HEADING_LEVELS,
  m as HORIZONTAL_ALIGNS,
  o as LOGGER_LEVELS,
  e as MODAL_SIZES,
  t as PADDING_SIZES,
  r as SYSTEM_VALIDATION_STATUSES,
  h as TEXT_ALIGNS,
  T as TEXT_ELEMENTS,
  s as TEXT_FIELD_TYPES,
  S as TEXT_MODES,
  E as TEXT_VARIANTS,
  p as VERTICAL_ALIGNS
};
